<template>
  <div class="mobile-wrapper">
    <intro-header />
    <div>
      <div class="intromain" :style="containerStyles">
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IntroHeader from "./introheaderMobile.vue";
import Resturants from "./Resturant/ResturantsMobile.vue";
import shared from "../../sharedscripts/master/Intro.js";
import { DetectBrand } from "../../mixins/brandDetector";

export default {
  name: "IntroMobile",
  components: {
    IntroHeader,
    Resturants
  },
  data() {
    return {
      ...shared.data()
    };
  },
  computed: {
    ...mapGetters([
      "hqDoc",
    ]),
    showLoginButton() {
      return this.hqDoc &&
        this.hqDoc.ViewComponentConfigs &&
        this.hqDoc.ViewComponentConfigs.LogIn === true &&
        DetectBrand.methods.isBranded() === true;
    },
    containerStyles() {
      return this.showLoginButton ? {top: '109px'} : {top: 'calc(89px - 1.5rem)'};
    }
  }
};
</script>
